<template>
    <div>
        <div v-show="visible && modal" class="side-wrapper" @click="modalClick" />
        <transition name="slide-fade">
            <div v-show="visible" class="side-dialog">
                <div class="close-btn" @click="closeDialog">
                    <i class="el-icon-close" style="font-size: 20px;color: #999;padding: 10px;" />
                </div>
                <div class="side-dialog-title">{{ title }}</div>
                <div ref="content" v-loading="loading" class="side-dialog-content">
                    <slot name="content" />
                    <div v-if="hasFooter" class="side-dialog-footer">
                        <slot name="footer" />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "标题"
        },
        // 是否需要遮罩
        modal: {
            type: Boolean,
            default: false
        },
        // 点击遮罩是否关闭
        closeOnClickModal: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasFooter() {
            return !!(this.$slots && this.$slots.footer);
        }
    },
    methods: {
        closeDialog() {
            this.$emit('update:visible', false);
        },
        modalClick() {
            if(this.closeOnClickModal) {
                this.closeDialog();
            }
        }
    },
    watch: {
        visible(value) {
            if(!value) {
                this.$emit('close');
            }else {
                this.$nextTick(() => {
                    this.$refs.content.scrollTop = 0;
                });
            }
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
    .side-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
    }
    .side-dialog{
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        width: 750px;
        z-index: 500;
        background-color: #fff;
        box-shadow: -4px 0px 6px #e3e7ea;
        .side-dialog-title{
            height: 55px;
            line-height: 55px;
            border-bottom: 2px solid #eee;
            font-size: 16px;
            color: #333;
            text-align: center;
        }
        .close-btn{
            position: absolute;
            left: -20px;
            top: 0;
            z-index: 104;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #fff;
            box-shadow: -4px 0px 6px #e3e7ea;
            cursor: pointer;
        }
        .side-dialog-content{
            flex: 1;
            padding: 30px;
            overflow-x: hidden;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .slide-fade-enter-active {
        transition: transform .4s ease-out;
    }
    .slide-fade-leave-active {
        transition: all .4s ease;
    }

    .slide-fade-enter,
    .slide-fade-leave-to{
        opacity: 0;
        transform: translate3d(900px, 0, 0);
    }
</style>
